import { AbstractControl, ValidationErrors } from '@angular/forms';
import isEmail from 'validator/es/lib/isEmail';

export const emailValidator = (control: AbstractControl): ValidationErrors | null => {
    // If value is empty we don't check if value is correct.
    // You should use Validator.required validator if you want to require field
    if (!control.value) {
        return null;
    }

    if (!isEmail(control.value)) {
        return { email: { value: control.value } };
    }

    return null;
};
